// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tDyb","content":"styles_content__1wAja","row":"styles_row__2Gd9X","footer":"styles_footer__3oLyC","phraseLength":"styles_phraseLength__2WKjx"};